export const BACKEND_CLOUD_URL =
  "https://influencer-api.indiancashback.com/api/v2";
export const BACKEND_URL = "http://localhost:4000/api/v2";

export const REACT_ENV = "development";
